
import { DebugSoundRow } from "./DebugSoundRow";
import { Helper } from "../../../../utils/Helper";
import { ArrayHelper } from "../../../../utils/ArrayHelper";
import { TextStyleOptions } from "../../../../setting/text/IText";
import { NolimitHowl } from "@nolimitcity/slot-audio/bin/NolimitHowl";
import { SoundManager } from "../../../../../game/sound/SoundManager";
import { FontWeight } from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import { INolimitAudioPlayer } from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import { TimeCheckPoints } from "../../../../utils/TimeCheckPoints";
import { MathHelper } from "../../../../utils/MathHelper";
import { DebugTabData } from "../DebugMenuButton";
import {  gsap } from "gsap";

export class DebugSoundBar extends PIXI.Container implements DebugTabData {

    private text:PIXI.Text;
    private soundPlayer:INolimitAudioPlayer;
    private checkPointName:string = "DEBUG_SOUND";

    private rows:DebugSoundRow[] = [];
    private deletes:DebugSoundRow[] = [];

    private loaded:boolean = false;

    private DEFAULT_TEXT_STYLE:TextStyleOptions = {
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 10,
        dropShadowDistance: 2,
        fontFamily : "Helvetica",
        fontWeight : FontWeight.BOLD,
        fontSize: 28,
        align:"left",
        wordWrap: true,
        wordWrapWidth: 400,
        fill: [
            "white",
        ]
    };

    private get players():NolimitHowl[]{
        return this.soundPlayer.allPlayers();
    }

    private tl:gsap.core.Timeline;
    public get activated():boolean{
        return this.visible;
    }

    constructor(soundPlayer:INolimitAudioPlayer){
        super();
        this.init();

        this.soundPlayer = soundPlayer;
        this.visible = false;
    }

    public init():void {
        this.text = this.addChild(new PIXI.Text("Sound", this.DEFAULT_TEXT_STYLE));

        this.position.set(115,-155);
    }

    public toggle():void{
        this.visible = !this.visible;
        this.activateLoop();
    }
    private activateLoop():void{
        this.tl = Helper.setTimeline(this.tl,new gsap.core.Timeline({
            onRepeat:() => { if(this.visible) this.updateSoundData(); },
            repeat: this.visible ? -1 : 0
        }))

        if(this.visible){
            TimeCheckPoints.setCheckPoint(this.checkPointName);
            this.tl.to(this,{duration:MathHelper.frameToSeconds(1)});
        }else{
            TimeCheckPoints.removeCheckPoint(this.checkPointName);
        }
    }

    private updateSoundData():void {
        const playing:NolimitHowl[] =  this.players.filter(p => p && p.isPlaying && !p.isMuted());

        if(!this.loaded){
            this.loaded = !!this.players[0];
            this.text.text = this.loaded ? "Sound" : "Sound - Not loaded";
        }

        if(playing.length < this.rows.length){
            let willRemove:boolean = true;
            let removed:boolean = false;
            do{
                removed = false;
                for(let r:number = 0; r < this.rows.length; r++){
                    willRemove = true;
                    for(let p:number = 0; p < playing.length; p++){
                        if(playing[p].soundName == this.rows[r].soundName){
                            willRemove = false;
                            break;
                        }
                    }
                    if(willRemove && !this.rows[r].isRemoving) {
                        this.rows[r].remove();
                        this.deletes.push(this.rows.splice(r,1)[0]);
                        removed = true;
                        break;
                    }
                }
            }while(removed)
        }

        this.deletes = this.deletes.filter(s => !s.isRemoved);
        this.deletes.forEach(d => d.updateValue())

        if(!playing.length) return;

        for(let p:number = 0; p < playing.length; p++){
            if(this.rows.findIndex(r => r.soundName === playing[p].soundName) < 0) {
                this.rows.push(this.addChild(new DebugSoundRow(playing[p])));
            }
        }

        this.sortUpwards();
        this.rows.forEach(v => v.updateValue());
    }

    public sortUpwards():void{

        const currPosOccupied:number[] = this.rows.map((v) => v.ID).concat(this.deletes.map((v) => v.ID));

        this.rows.forEach((r,i) => {
            let nextID:number = i;
            while(currPosOccupied.indexOf(nextID) >= 0) nextID++;
            if(nextID > r.ID) return;
            r.setRowID(nextID);
        });
        this.rows.sort((a,b) => a.ID - b.ID);
    }

    public hide():void{
        this.visible = false;
        this.activateLoop();
    }
}